module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/trashUB.a5c924ca.svg";